import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TokenfieldComponent } from '../../../../../shared';

@Component({
    selector: 'sgt-campanha-cupons-form',
    templateUrl: './campanha-cupons-form.component.html',
    styleUrls: ['./campanha-cupons-form.component.less']
})
export class CampanhaCuponsFormComponent {
    /** Cupons da campanha */
    @Input() cupons: string[] =[];
    /** Ao alterar os cupons da campanha */
    @Output() cuponsChange = new EventEmitter<string[]>();
    /** Se pode editar o form */
    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;
    @ViewChild('cuponsTokenfield') cuponsTokenfield: TokenfieldComponent;

    /** Verifica se o form está válido */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        if (this.form.invalid) {
            this.cuponsTokenfield?.setFocus();
            return false;
        }
        return true;
    }
}
